import React, { Component } from 'react'
import { graphql, gql, compose } from 'react-apollo'
import { translate } from 'react-i18next'

import PropTypes from 'prop-types'
import get from 'lodash/get'

import { client } from './../../index'
import { NotificationManager } from 'react-notifications'

import Comment from './Comment'
import CommentForm from './CommentForm'

import { CREATE_EVENT_COMMENT, CREATE_NOTE_COMMENT, GET_EVENT_COMMENTS, GET_NOTE_COMMENTS, DELETE_COMMENT } from './../../graphql/MyTrip'

class CommentList extends Component {
  static propTypes = {
    contentEventId: PropTypes.string,
    customizedPlanId: PropTypes.string,
    commentsQuery: PropTypes.shape({
      allContentEventComments: PropTypes.array,
      subscribeToMore: PropTypes.func,
      refetch: PropTypes.func
    }),
    createEventComment: PropTypes.func,
    deleteComment: PropTypes.func
  }

  static defaultProps = {
    contentEventId: '',
    customizedPlanId: ''
  }

  constructor(props) {
    super(props)

    this.state = {
      isOpen: false,
      customizedPlan: {}
    }
  }

  componentWillReceiveProps(next) {
    if (!next.customizedPlanId) return

    const { CustomizedPlan } = client.readQuery({
      query: gql`
        query ($id: bpchar!) {
          customizedplan(where: {id: {_eq: $id}}) {
            orderingUser {
              id
            }
            tripGuru {
              id
            }
          }
        }
      `,
      variables: {
        id: next.customizedPlanId
      }
    })

    this.setState(() => ({
      customizedPlan: CustomizedPlan
    }))
  }

  toggleComments(e) {
    e.stopPropagation()

    this.setState(state => ({
      isOpen: !state.isOpen
    }))
  }

  async sendEventComment(content) {
    try {
      await this.props.createEventComment({
        variables: {
          authorId: this.props.user.id,
          contentEventId: this.props.contentEventId,
          content
        }
      })

      await this.props.commentsQuery.refetch()
    } catch (err) {
      NotificationManager.error(err.message, 'Error', 5000)
    }
  }

  async sendNoteComment(content) {
    try {
      await this.props.createNoteComment({
        variables: {
          authorId: this.props.user.id,
          noteId: this.props.noteId,
          content
        }
      })

      await this.props.noteCommentsQuery.refetch()
    } catch (err) {
      NotificationManager.error(err.message, 'Error', 5000)
    }
  }


  async onCommentDelete(id) {
    try {
      await this.props.deleteComment({
        variables: { id }
      })

      await this.props.commentsQuery.refetch()
    } catch (err) {
      NotificationManager.error(err.message, 'Error', 5000)
    }
  }

  renderCommentsCount() {
    const { allContentEventComments } = this.props.contentEventId ? this.props.commentsQuery : this.props.noteCommentsQuery

    let result = this.props.t('comments')

    if (Array.isArray(allContentEventComments) && allContentEventComments.length) {
      result += ` (${allContentEventComments.length})`
    }

    return result
  }

  renderComments() {
    const { allContentEventComments: comments } = this.props.contentEventId ? this.props.commentsQuery : this.props.noteCommentsQuery

    if (Array.isArray(comments) && comments.length) {
      const tripGuruId = get(this.state, 'customizedPlan.tripGuru.id')
      const userId = get(this.props, 'user.id')

      const isTripGuru = tripGuruId === userId

      return comments.map((comment, i) => {
        let isDeleteAvailable = false

        if (isTripGuru || comment.author.id === userId) {
          isDeleteAvailable = true
        }

        return (
          <Comment
            key={i}
            data={comment}
            isDeleteAvailable={isDeleteAvailable}
            onDeleteClick={commentId => this.onCommentDelete(commentId)}
          />
        )
      })
    }

    return null
  }

  render() {
    return (
      <div className="comment-list__wrapper">
        <div
          className="comment-list__switch"
          onClick={e => {
            this.toggleComments(e)
          }}
        >
          <i className="fa fa-comments" /> <span>{this.renderCommentsCount()}</span>
        </div>

        {this.state.isOpen && (
          <div className="comment-list">
            {this.renderComments()}
            <CommentForm
              onSendButtonClick={e => (this.props.contentEventId ? this.sendEventComment(e) : this.sendNoteComment(e))}
              onCloseButtonClick={e => {
                this.toggleComments(e)
              }}
            />
          </div>
        )}
      </div>
    )
  }
}

export default compose(
  graphql(CREATE_EVENT_COMMENT, {
    name: 'createEventComment'
  }),
  graphql(CREATE_NOTE_COMMENT, {
    name: 'createNoteComment'
  }),
  graphql(GET_EVENT_COMMENTS, {
    name: 'commentsQuery',
    options: props => ({
      variables: {
        contentEventId: props.contentEventId || ''
      }
    })
  }),
  graphql(GET_NOTE_COMMENTS, {
    name: 'noteCommentsQuery',
    options: props => ({
      variables: {
        noteId: props.noteId || ''
      }
    })
  }),
  graphql(DELETE_COMMENT, {
    name: 'deleteComment'
  }),
  translate('my_trip')
)(CommentList)




// WEBPACK FOOTER //
// src/components/MyTrip/CommentList.js